<ul class="segment" [ngClass]="{ 'mod-light': light }">
  @for (option of options; track option) {
    <li
      class="segment-button"
		[ngClass]="{
			'segment-button-selected': option === this?.selected,
			'segment-button--is-icon': icon,
			'mod-spaced': isSpaced
		}"
      (click)="onOptionClick(option)"
      (keydown.enter)="onOptionClick(option)"
      [tabindex]="0">
      @if (!icon) {
        <span class="white-space-nowrap">{{ option?.name | translate }}</span>
      }
      @if (icon) {
        <span class="{{ option?.name }}"></span>
      }
    </li>
  }
</ul>
